// extracted by mini-css-extract-plugin
export default {"rupee":"E_qGGG"};